import { registerPlugin } from "@capacitor/core";

export const ExternalPurchaseNative = registerPlugin("ExternalPurchase");
